import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GenericActionsComponent } from '../../generic-actions/generic-actions.component';
import { GenericMenuItem } from '../../generic-menu/generic-menu-item.model';

/**
 * This component is responsible for the display of standardized dialog content. Optionally, generic menu
 * items can be provided, which will be displayed inbetween the title and the close icon button.
 *
 * @export
 */
@Component({
  selector: 'hypecast-admin-dialog-header',
  templateUrl: './dialog-header.component.html',
  styleUrl: './dialog-header.component.scss',
  standalone: true,
  imports: [MatIconModule, MatDividerModule, MatButtonModule, MatTooltipModule, GenericActionsComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogHeaderComponent {
  // This tooltip text will be displayed inside the tooltip of the close icon button
  readonly closeTooltipText = input<string>('Close the dialog');

  readonly showCloseButton = input<boolean>(true);

  // Determines whether the divider should be visible or not
  readonly dividerIsVisible = input<boolean>(true);

  // These generic menu items will be displayed in between the title and the close icon button
  readonly items = input<GenericMenuItem[]>([]);

  readonly title = input<string>('');

  readonly emitCloseClick = output<boolean>();
}
